import React from 'react';
import './LinkImage.css';

export const LinkImage = ({ linkName, link, image }) => (
    <a id={`${linkName}Link`} href={link} target="_blank" rel="noreferrer">
        <img className="storeIcon" src={image} alt={linkName} />
    </a>
);

export default LinkImage;
